setLiveAccessScheduleError